/**
 * Whether the user has asked for reduced motion, read at the moment of the
 * decision rather than subscribed to: callers pick a branch as an animation
 * starts and none needs to react to the setting changing mid-animation.
 *
 * The `typeof` guard is not decoration — jsdom has no `matchMedia` of its own,
 * so calling through would throw wherever the environment supplies none.
 *
 * The CSS half of this is Tailwind's `motion-reduce:` variant; reach for that
 * first. This is for transitions driven from JS, where there is also a timer or
 * a scroll behaviour to skip.
 */
export const prefersReducedMotion = () =>
  typeof window.matchMedia === 'function' &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
